/**
 * Clés i18n des rôles d'équipe (`owner|admin|member|viewer`) — littérales dans l'objet, comme
 * `RoleBadge::ROLE_LABEL_KEYS` : le gate `keys.test.js` ne voit pas `t(variable)`.
 *
 * Distinct de `RoleBadge` (rôles d'ORGANISATION, `roleBadge.*`) : « roleLabels: organisation =
 * roleBadge (Administrateur) ; équipe = roles (Admin) » (217:4531, décisions 2026-09-27) — les
 * deux univers de rôles ne partagent pas leurs libellés, même quand le mot recouvre le même
 * rang (`admin`).
 */
export const TEAM_ROLE_KEYS = {
  owner: 'roles.owner',
  admin: 'roles.admin',
  member: 'roles.member',
  viewer: 'roles.viewer',
};
